__webpack_require__.p = "https://reports.dev.core-artifacts.com/static/";